import * as React from "react"
import { connect } from "react-redux"

import { Modal } from "@tenforce/toolbox-modal-react"
import {
    Body,
    CompleteFooter,
    LoadingBody,
    Table,
} from "@tenforce/toolbox-table-react"

import { GlobalState } from "../../../../store"

import { DispatchProps, mapDispatchToProps } from "../../actions"

import Editor from "./Editor"
import Row from "./Row"
import TableHeader from "./TableHeader"
import { Labels } from "../../../../util/Translations"

declare let window: OldUIContext.TenForceWindow

type StateProps = Deployment.Deployment

type Props = StateProps & DispatchProps

export class Export extends React.PureComponent<Props> {
    render(): JSX.Element {
        const { configurations, editor, configurationsLoading } = this.props

        return (
            <>
                <Table data-ft-exports-table>
                    <TableHeader />

                    {configurationsLoading ? (
                        <LoadingBody id="exportsLoading" />
                    ) : (
                        <Body>
                            {configurations
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((configuration) => (
                                    <Row
                                        key={configuration.id}
                                        configuration={configuration}
                                        onExport={this.export}
                                        onEdit={this.requestSource}
                                        onRemove={this.remove}
                                    />
                                ))}
                        </Body>
                    )}

                    <CompleteFooter />
                </Table>

                <Modal
                    isShown={editor.visible}
                    containerProps={{
                        isCenterFixedPositioned: true,
                        onClose: this.closeEditor,
                    }}
                    contentProps={{
                        extraClasses: "tw-mx-1/12 bg-default",
                    }}
                >
                    <Editor />
                </Modal>
            </>
        )
    }

    export = (id: string): void => {
        const { exportConfiguration } = this.props
        window.feedback.clear()
        const { ExportPackage } = Labels
        window.feedback.displayInfo(`${ExportPackage}...`, false, false)
        // start polling for feedback immediately.
        window.feedback.scheduleGetFeedbackMessages()
        exportConfiguration(id)
    }

    requestSource = (id: string): void => {
        const { requestSource } = this.props
        requestSource(id)
    }

    remove = (id: string): void => {
        const { removeConfiguration } = this.props
        const { AreYouSure } = Labels
        if (confirm(AreYouSure)) {
            removeConfiguration(id)
        }
    }

    closeEditor = (): void => {
        const { closeEditor } = this.props
        closeEditor()
    }
}

const mapStateToProps = (state: GlobalState): StateProps => state.deployment

export default connect(mapStateToProps, mapDispatchToProps)(Export)
